<template>
    <div class='player_div' :style="{width: width, height: height}">
        <video-player class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      @my-playerStateChanged="playerStateChanged"
                      @play="onPlayerPlay"
                      @ended="onPlayerEnded"
                      :playsinline="true"
                      :options="playerOptions">
<!--            @ready="playerReadied"-->
<!--            @loadeddata="onPlayerLoadeddata($event)"-->
<!--            @canplay="onPlayerCanplay($event)"-->
<!--            @canplaythrough="onPlayerCanplaythrough($event)"-->
<!--            @play="onPlayerPlay($event)"-->
<!--            @playing="onPlayerPlaying($event)"-->
<!--            @timeupdate="onPlayerTimeupdate($event)"-->
<!--            @pause="onPlayerPause($event)"-->
<!--            @waiting="onPlayerWaiting($event)"-->
<!--            @ended="onPlayerEnded($event)"-->
<!--            @statechanged="playerStateChanged($event)"-->
        </video-player>
    </div>
</template>

<script>
    import common from "../../js/common";

    export default {
        name: "Wp_video_player",
        props: {
            width: {type: String, default: common.screenWidth + 'px'},
            height: {type: String, default: common.screenWidth + 'px'},
            posterImage:{type: String, default: ''},//封面图片地址
            autoPlay: {type: Boolean, default: false},
            url: {type: String, default: ''},
            ratio:{type: String, default: '1:1'},
            fullscreen: {type: Boolean, default: false},
            noAudio: {type: Boolean, default: true},

        },
        data() {
            return {
                playerOptions: {
                    //播放速度
                    // playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: true,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '1:1',
                    // aspectRatio: '4:3',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: 'https://vod.300hu.com/4c1f7a6atransbjngwcloud1oss/6ab4c898217586504443691009/v.f20.mp4?dockingId=b1ec2ba5-9a77-41bd-a6dc-e1fce722cee1&storageSource=3'
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    },
                    play: 'my-playerStateChanged',
                    // width: this.$common.screenWidth + 'px',

                },
            }
        },

        created() {
            this.initVideoOptions();
        },
        mounted() {
            // this.$refs.videoPlayer.player.play();
            // if(this.fullscreen){
            //     this.fullScreenPlay();
            // }
        },

        methods:{
            initVideoOptions(){
                this.playerOptions.poster = this.posterImage;
                this.playerOptions.autoplay = this.autoPlay;
                this.playerOptions.sources[0].src = this.url;
                this.playerOptions.aspectRatio = this.ratio;
                this.playerOptions.muted = this.noAudio;
            },
            playerStateChanged(currentState){
                this.$log(currentState)
                //没有生效
            },
            onPlayerPlay(event){
                this.$log('------------onPlayerPlay-----------' + event);
                this.$emit('onPlayerPlay', event)
            },
            onPlayerEnded(event){
                this.$log('------------onPlayerEnded-----------' + event);
                this.$emit('onPlayerEnded')
            },

            fullScreenPlay() {
                let player = this.$refs.videoPlayer.player;
                player.requestFullscreen();//调用全屏api方法
                player.isFullscreen(true);
                player.play();
            }
        }

    }
</script>

<style >
    .player_div{
        display: inline-block;
        /*width: 600px;*/
        /*height: 338px;*/
        text-align: center;
        /*line-height: 100px;*/
        /*border: 1px solid transparent;*/
        /*border-radius: 4px;*/
        overflow: hidden;
        /*background: #fff;*/
        position: relative;
        /*box-shadow: 0 1px 1px rgba(0, 0, 0, .2);*/
        /*margin-right: 4px;*/
    }

    .player_div:hover{
        display: block;
    }

    .video-js .vjs-icon-placeholder {
       width: 100%;
       height: 100%;
       display: block;
    }

    .video-js .vjs-big-play-button{
        height: 70px !important;
        width: 70px !important;
        line-height: 70px !important;
        text-align: center;
        background:rgba(0, 0, 0, 0.5) !important;
        border-radius: 50px !important;
        top: 50% !important;
        left: 50% !important;
        margin-left: -35px !important;
        margin-top: -35px !important;
    }

</style>